import React from 'react';
import { d as _objectWithoutProperties } from './_rollupPluginBabelHelpers-2e5b701d.js';
import PropTypes from 'prop-types';
import { T as Tooltip } from './index-efb29065.js';
import { s as styleInject } from './style-inject.es-1f59c1d0.js';
import WithTooltip from './overlays/withTooltip.js';

var css_248z = ".Icon_icon__3GAdt {\n  width: 21px;\n  height: 21px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .Icon_icon__3GAdt > span {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .Icon_icon__3GAdt svg {\n    width: 100%;\n    height: 100%; }\n  .Icon_icon__3GAdt.Icon_extra-small__1VIh- {\n    width: 12px;\n    height: 12px; }\n  .Icon_icon__3GAdt.Icon_small__NR7RC {\n    width: 16px;\n    height: 16px; }\n  .Icon_icon__3GAdt.Icon_big__30g7F {\n    width: 25px;\n    height: 25px; }\n\n.Icon_translucent__2p57- {\n  opacity: 0.5; }\n";
var styles = {"icon":"Icon_icon__3GAdt","extra-small":"Icon_extra-small__1VIh-","small":"Icon_small__NR7RC","big":"Icon_big__30g7F","translucent":"Icon_translucent__2p57-"};
styleInject(css_248z);

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var InfoIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm0-1c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM10 9.5h3v8h1v.5h-4v-.5h1V10h-1v-.5zM11.75 8a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z",
  fill: "#333",
  fillRule: "evenodd"
})));

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var InfoIconV2 = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Final",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "user_says_dropdown",
  transform: "translate(-942 -189)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(934 181)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_info",
  transform: "translate(8 8)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "base",
  x: "0",
  y: "0",
  width: "24",
  height: "24",
  rx: "2"
}), /*#__PURE__*/React.createElement("g", {
  id: "info",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "ic_info_background",
  fill: "#3C71E1",
  x: "0",
  y: "0",
  width: "16",
  height: "16",
  rx: "2"
}), /*#__PURE__*/React.createElement("text", {
  id: "i",
  fontFamily: "Roboto-Bold, Roboto",
  fontSize: "12",
  fontWeight: "bold",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: "6.5",
  y: "12.5"
}, "i")))))))));

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var InfoIconV3 = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$2({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.2 4h1.6v1.6H7.2V4zm0 3.2h1.6V12H7.2V7.2zM8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 14.4A6.408 6.408 0 011.6 8c0-3.528 2.872-6.4 6.4-6.4 3.528 0 6.4 2.872 6.4 6.4 0 3.528-2.872 6.4-6.4 6.4z",
  fill: "#858585"
})));

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var UserSaysIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$3({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 3)",
  stroke: "#333",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: "9",
  cy: "9",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  id: "user-says-shade-1",
  d: "M10.788 3.736c.963.557 1.606 1.556 1.606 2.697 0 .14-.01.277-.028.412.129.527.2 1.094.2 1.684a.523.523 0 01.518.589l-.18 1.28a.518.518 0 01-.704.408 5.212 5.212 0 01-.965 1.722v2.817h-4.42v-2.817a5.217 5.217 0 01-.968-1.732.514.514 0 01-.698-.404l-.18-1.27a.519.519 0 01.514-.583c0-.594.07-1.164.2-1.694a3.004 3.004 0 01-.027-.412c0-1.583 1.238-2.895 2.855-3.128.441-.155 1.341-.443 1.91-.443.395 0 .429.44.367.874z",
  fill: "#DDD"
}), /*#__PURE__*/React.createElement("path", {
  id: "user-says-shade-2",
  d: "M14.95 15.69a41.098 41.098 0 00-3.068-.96l-.173-.385H6.342l-.173.385a41.066 41.066 0 00-3.066.96s1.64 2.3 5.927 2.3 5.92-2.3 5.92-2.3z",
  fill: "#DDD"
}))));

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var BotSaysIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$4({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 3)",
  stroke: "#333",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 0h0a7 7 0 017 7v7a4 4 0 01-4 4H4a4 4 0 01-4-4V7a7 7 0 017-7z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#DDD",
  x: "2",
  y: "5",
  width: "10",
  height: "3",
  rx: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 11v4"
}))));

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var EntitiesIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$5({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "#333",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.897 7.31L11 4.89a1.99 1.99 0 011.436 0l6.102 2.42c.767.305 1.068 1.029.671 1.617-.114.17-.28.317-.484.428l-6.102 3.325a1.96 1.96 0 01-1.81 0L4.71 9.355c-.704-.384-.87-1.133-.37-1.673.145-.156.336-.284.557-.371z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.646 10.45c.647.257.688.728.096 1.05l-6.95 3.788c-.593.323-1.558.322-2.15 0L3.692 11.5c-.593-.324-.546-.796.096-1.05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.646 13.15c.647.257.688.728.096 1.05l-6.95 3.788c-.593.323-1.558.322-2.15 0L3.692 14.2c-.593-.324-.546-.796.096-1.05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.646 15.85c.647.257.688.728.096 1.05l-6.95 3.788c-.593.323-1.558.322-2.15 0L3.692 16.9c-.593-.324-.546-.796.096-1.05"
}))));

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var ConnectionsIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$6({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "#333",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.795 6h3.706v3.706"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.46 6l-7.653 7.653-3.083-3.083L3 17.294"
}))));

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var ApiIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$7({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon10",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.974 12.984c.428-4.9-3.21-9.222-8.129-9.652",
  id: "Oval-474",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.106 14.11C17.73 6.976 12.432.685 5.271.058",
  id: "Oval-473",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: "5.143",
  cy: "12.857",
  r: "5.143"
})))))));

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var GearIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$8({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "#333",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.441 12.877c.036-.288.063-.58.063-.877 0-.297-.027-.59-.063-.877l1.904-1.49a.449.449 0 00.108-.576l-1.8-3.119c-.113-.193-.347-.274-.55-.193l-2.24.904a6.829 6.829 0 00-1.521-.886l-.338-2.385a.463.463 0 00-.45-.378h-3.6a.454.454 0 00-.445.378L9.17 5.763a6.66 6.66 0 00-1.52.886l-2.242-.904a.45.45 0 00-.549.193l-1.8 3.119a.45.45 0 00.108.576l1.9 1.49c-.037.287-.064.58-.064.877 0 .297.027.59.063.877l-1.899 1.49a.449.449 0 00-.108.576l1.8 3.118a.445.445 0 00.55.194l2.24-.905c.464.356.972.657 1.521.887l.338 2.385c.036.211.22.378.445.378h3.6c.225 0 .41-.167.446-.378l.337-2.385a6.66 6.66 0 001.521-.887l2.241.905a.45.45 0 00.55-.194l1.8-3.118a.45.45 0 00-.109-.576l-1.899-1.49z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.604 12a3.148 3.148 0 013.15-3.15 3.148 3.148 0 013.15 3.15 3.148 3.148 0 01-3.15 3.15A3.148 3.148 0 018.604 12z"
}))));

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var CloseIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$9({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 3)",
  stroke: "#333",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: "9",
  cy: "9",
  r: "9"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#DDD"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 13L5 5l8 8zM5 13l8-8-8 8z"
})))));

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var CloseV2Icon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$a({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Final",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "debug_user_says_already_exist",
  transform: "translate(-392 -56)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Test-bot",
  transform: "translate(64 48)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_cross",
  transform: "translate(328 8)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Line",
  stroke: "#333",
  strokeLinecap: "round",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 17.314L17.314 6M6 6l11.314 11.314"
}))))))));

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var InactiveIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$b({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "9",
  r: "9",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M14.034 16.25L4.107 1.794l9.927 14.456z"
}))));

function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var ActiveIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$c({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 3)",
  stroke: "#333",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: "9",
  cy: "9",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.287 5.942l-6.095 6.367L4.56 9.81"
}))));

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var EditIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$d({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  stroke: "#333",
  fillRule: "evenodd",
  strokeLinecap: "square",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.124 5.403l3.077 3.077-9.917 9.917-3.696.62.62-3.697z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.203 4.325l3.077 3.077-3.481 3.48-3.077-3.076z"
}))));

function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var InvisibleIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$e({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 001 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
})));

function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var VisibleIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$f({
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Final",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "mockup-09",
  transform: "translate(-747 -653)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(595 640)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/view",
  transform: "translate(152 9)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_visibility_black_24px"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
  id: "Shape",
  stroke: "#333",
  fillRule: "nonzero"
}))))))));

function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SaveIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$g({
  fill: "#777",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
})));

function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var HelpIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$h({
  fill: "#777",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 2H5a2 2 0 00-2 2v14a2 2 0 002 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
})));

function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var AddIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$i({
  fill: "#777",
  height: "15",
  viewBox: "0 0 24 24",
  width: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})));

function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var TrashIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$j({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon11",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 18.75C5 19.988 6.038 21 7.308 21h10.384C18.962 21 20 19.988 20 18.75V7.5H5v11.25zM20 3.964h-5.77L13.243 3h-1.484l-.989.964H5v1.768h15V3.964z",
  id: "Shape",
  fill: "#FFF",
  fillRule: "nonzero",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 10.571v6.858M12.5 10.571v6.858M8.5 10.571v6.858",
  id: "Line",
  strokeLinecap: "square"
})))));

function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var HomeIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$k({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon12",
  stroke: "#858585"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M10 21v-6h4v6h5v-8h3L12 4 2 13h3v8z"
})))));

function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SynonymHighlightIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$l({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon13",
  transform: "translate(4 4)",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-192",
  transform: "rotate(45 9.841 6.409)",
  d: "M7.591-.341h4.5v13.5h-4.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-192",
  transform: "rotate(45 2.84 13.41)",
  d: "M1.49 12.06h2.7v2.7h-2.7z"
})))));

function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var CloneIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$m({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon14",
  fill: "#FFF",
  fillRule: "nonzero",
  stroke: "#333",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 12.75c0 1.238 14.625 1.238 14.625 0V1.5C18.625.292 4-.031 4 1.5v11.25z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 16.75c0 1.238 14.625 1.238 14.625 0V5.5C14.625 4.292 0 3.969 0 5.5v11.25z",
  id: "Shape"
})))));

function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var PlusIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$n({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "9",
  fill: "#FFF",
  transform: "rotate(45 12 12)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 17.657V6.343v11.314zM6.343 12h11.314H6.343z",
  fill: "#DDD"
}))));

function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var Plus2Icon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$o({
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(1 1)",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFF",
  cx: "9",
  cy: "9",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 14.657V3.343v11.314zM3.343 9h11.314H3.343z",
  id: "Shape",
  fill: "#DDD",
  fillRule: "nonzero"
})))));

function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
var MinusIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$p({
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(1 1)",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFF",
  cx: "9",
  cy: "9",
  r: "9"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(3 9)",
  fill: "#DDD",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.343 0h11.314H.343z",
  id: "Shape"
}))))));

function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var AddDelayIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$q({
  width: "36",
  height: "36",
  viewBox: "0 0 36 36"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/add-delay",
  stroke: "#AB4040",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 17h0c0 6.075-4.925 11-11 11h0C4.925 28 0 23.075 0 17h0C0 10.925 4.925 6 11 6h0c6.075 0 11 4.925 11 11z",
  id: "Rectangle-314",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  d: "M11.177 9.719v8.106l3.276 3.276"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 8V0",
  id: "Rectangle-314"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 8V0",
  id: "Rectangle-314",
  transform: "rotate(90 24 4)"
}))))));

function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var AddEntityIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$r({
  width: "36",
  height: "36",
  viewBox: "0 0 36 36"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/add-entity",
  stroke: "#5D86CA",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(1 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.662 5.016L15.647.263a3.91 3.91 0 012.82 0l11.986 4.753c1.507.598 2.097 2.02 1.318 3.176-.225.334-.55.622-.95.84l-11.986 6.531c-1.065.58-2.491.58-3.556 0L3.293 9.032c-1.383-.754-1.708-2.225-.726-3.287a2.981 2.981 0 011.095-.729z",
  id: "Rectangle-314"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.696 11.278c1.27.504 1.352 1.43.189 2.063L19.234 20.78c-1.166.635-3.06.634-4.224 0L1.36 13.34c-1.166-.635-1.074-1.562.188-2.063M17 12V4",
  id: "Rectangle-314"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 12V4",
  id: "Rectangle-314",
  transform: "rotate(90 17 8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.696 16.582c1.27.503 1.352 1.429.189 2.063l-13.651 7.438c-1.166.635-3.06.634-4.224 0L1.36 18.645c-1.166-.636-1.074-1.563.188-2.063",
  id: "Rectangle-314"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.696 21.885c1.27.504 1.352 1.429.189 2.063l-13.651 7.438c-1.166.636-3.06.634-4.224 0L1.36 23.948c-1.166-.636-1.074-1.563.188-2.063",
  id: "Rectangle-314"
}))))));

function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var BotSaysColoredIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$s({
  width: "36",
  height: "36",
  viewBox: "0 0 36 36"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/bot-says",
  fill: "#A2CE70",
  stroke: "#89BF4B",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34 6v16.889a4 4 0 01-4 4h-9.837L11.48 34v-7.111H6a4 4 0 01-4-4V6a4 4 0 014-4h24a4 4 0 014 4z",
  id: "Rectangle-314"
})))));

function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var DelayIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$t({
  width: "36",
  height: "36",
  viewBox: "0 0 36 36"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/delay",
  stroke: "#AB4040",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 16h0c0 8.837-7.163 16-16 16h0C7.163 32 0 24.837 0 16h0C0 7.163 7.163 0 16 0h0c8.837 0 16 7.163 16 16z",
  id: "Rectangle-314",
  fill: "#F28080"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  d: "M16.257 5.41V17.2l4.766 4.766"
}))))));

function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var EntityIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$u({
  width: "36",
  height: "36",
  viewBox: "0 0 36 36"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/entity",
  stroke: "#5D86CA",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(1 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.727 5.111L15.712.358a3.91 3.91 0 012.82 0l11.986 4.753c1.507.598 2.097 2.02 1.318 3.176-.15.223-4.462 2.68-12.936 7.371-1.065.58-2.491.58-3.556 0L3.36 9.127c-1.383-.754-1.709-2.225-.727-3.286a2.981 2.981 0 011.095-.73z",
  id: "Rectangle-314",
  fill: "#A4C6FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.696 11.278c1.27.504 1.352 1.43.189 2.063L19.234 20.78c-1.166.635-3.06.634-4.224 0L1.36 13.34c-1.166-.635-1.074-1.562.188-2.063",
  id: "Rectangle-314"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.696 16.582c1.27.503 1.352 1.429.189 2.063l-13.651 7.438c-1.166.635-3.06.634-4.224 0L1.36 18.645c-1.166-.636-1.074-1.563.188-2.063",
  id: "Rectangle-314"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.696 21.885c1.27.504 1.352 1.429.189 2.063l-13.651 7.438c-1.166.636-3.06.634-4.224 0L1.36 23.948c-1.166-.636-1.074-1.563.188-2.063",
  id: "Rectangle-314"
}))))));

function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var EntityNumericRangeIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$v({
  width: "54",
  height: "54",
  viewBox: "0 0 54 54",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "image/entity-type/number",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  fontFamily: "RobotoCondensed-Regular, Roboto Condensed",
  fontSize: "22",
  fontStyle: "condensed",
  fontWeight: "normal",
  letterSpacing: "-.142"
}, /*#__PURE__*/React.createElement("text", {
  id: "1-2-3-4",
  fill: "#333"
}, /*#__PURE__*/React.createElement("tspan", {
  x: "14",
  y: "22"
}, "1 2"), " ", /*#__PURE__*/React.createElement("tspan", {
  x: "14",
  y: "47"
}, "3 4")))));

function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var EntityRegexIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$w({
  width: "50",
  height: "50",
  viewBox: "0 0 50 50",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    background: "#fff"
  }
}, props), /*#__PURE__*/React.createElement("g", {
  id: "regex",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.892 41.244c-4.636-2.584-7.448-8.322-7.448-16.226 0-7.942 2.812-13.642 7.448-16.226v1.862c-3.116 2.584-5.13 7.258-5.13 14.364 0 7.106 2.014 11.742 5.13 14.326v1.9zM18.21 36v-3.686h3.116V36H18.21zm9.234-16.036l.38-4.37-3.04 2.394-.95-1.558 3.534-1.786-3.534-1.748.95-1.596 3.04 2.394-.38-4.332h1.824l-.418 4.332 3.078-2.394.912 1.596-3.534 1.748 3.534 1.786-.912 1.558-3.078-2.394.418 4.37h-1.824zm6.954 21.28v-1.9c3.154-2.584 5.13-7.22 5.13-14.326 0-7.106-1.976-11.78-5.13-14.364V8.792c4.674 2.584 7.486 8.284 7.486 16.226 0 7.904-2.812 13.642-7.486 16.226z",
  id: "(.*)",
  fill: "#333"
}))));

function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var BudgetIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$x({
  width: "54",
  height: "54",
  viewBox: "0 0 54 54",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "entity-types-images/time-copy",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  fontFamily: "RobotoCondensed-Regular, Roboto Condensed",
  fontSize: "22",
  fontStyle: "condensed",
  fontWeight: "normal",
  letterSpacing: "-.142"
}, /*#__PURE__*/React.createElement("text", {
  id: "1-Lakh",
  fill: "#333"
}, /*#__PURE__*/React.createElement("tspan", {
  x: "22.141",
  y: "22"
}, "1"), " ", /*#__PURE__*/React.createElement("tspan", {
  x: "7.019",
  y: "47"
}, "Lakh")))));

function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
var DateIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$y({
  width: "54",
  height: "54",
  viewBox: "0 0 54 54",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "entity-types-images/date",
  stroke: "#333",
  strokeWidth: "2",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.343 7H8.657C6.674 7 5 8.686 5 10.826v35.348C5 48.25 6.612 50 8.657 50h37.686C48.326 50 50 48.314 50 46.174V10.826C50 8.686 48.388 7 46.343 7z",
  id: "Shape",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42 45H13a3 3 0 01-3-3V19a3 3 0 013-3h29a3 3 0 013 3v23a3 3 0 01-3 3z",
  id: "Shape",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(15 3)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 5.5v-3A2.5 2.5 0 002.5 0h0A2.5 2.5 0 000 2.5v3A2.5 2.5 0 002.5 8h0A2.5 2.5 0 005 5.5zM25 5.5v-3A2.5 2.5 0 0022.5 0h0A2.5 2.5 0 0020 2.5v3A2.5 2.5 0 0022.5 8h0A2.5 2.5 0 0025 5.5z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(17 29)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.21 2.75v-1a1 1 0 00-1-1h-1a1 1 0 00-1 1v1a1 1 0 001 1h1a1 1 0 001-1zM12.21 2.75v-1a1 1 0 00-1-1h-1a1 1 0 00-1 1v1a1 1 0 001 1h1a1 1 0 001-1zM21.21 2.75v-1a1 1 0 00-1-1h-1a1 1 0 00-1 1v1a1 1 0 001 1h1a1 1 0 001-1z",
  id: "Shape"
})))));

function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var TimeIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$z({
  width: "54",
  height: "54",
  viewBox: "0 0 54 54",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "entity-types-images/time",
  stroke: "#333",
  strokeWidth: "2",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48 27h0c0 11.598-9.402 21-21 21h0C15.402 48 6 38.598 6 27h0C6 15.402 15.402 6 27 6h0c11.598 0 21 9.402 21 21z",
  id: "Rectangle-314",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  d: "M27.338 13.1v15.475l6.254 6.255"
}))));

function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var ReorderIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$A({
  width: "26",
  height: "26",
  viewBox: "1 1 26 26"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "bounds",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 4v5A1.5 1.5 0 004 10.5h5A1.5 1.5 0 0010.5 9V4A1.5 1.5 0 009 2.5H4A1.5 1.5 0 002.5 4zM13.5 15v5a1.5 1.5 0 001.5 1.5h5a1.5 1.5 0 001.5-1.5v-5a1.5 1.5 0 00-1.5-1.5h-5a1.5 1.5 0 00-1.5 1.5z",
  id: "Shape",
  stroke: "#333"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-1501",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8.119 19.037l-1.62 1.62-1.62-1.62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.94 14.807L4.116 19.63",
  id: "Path-3399",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "rotate(135 6.528 17.219)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-1501",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "rotate(-180 17.501 4.153)",
  d: "M19.121 3.343l-1.62 1.62-1.62-1.62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.883 4.37l-4.822 4.823",
  id: "Path-3399",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "rotate(-45 17.472 6.781)"
})))));

function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var MandatoryIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$B({
  width: "20",
  height: "20",
  viewBox: "0 0 25 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/text-blue",
  stroke: "#333",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 8h5M3 12h7M3 16h16M3 20h16",
  id: "Line"
})))));

function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var SuccessIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$C({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/tick",
  stroke: "#81c781"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy-4",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-1-Copy-2",
  cx: "9",
  cy: "9",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Oval-1-Copy-3",
  d: "M13.287 5.942l-6.095 6.367L4.56 9.81"
}))))));

function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var StarIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$D({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8.91 8.261L2 9.266l5 4.873-1.18 6.882L12 17.77l6.18 3.25L17 14.139l5-4.873-6.91-1.005L12 2z",
  fill: "none"
})));

function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var AngleDownIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$E({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/arrow"
}, /*#__PURE__*/React.createElement("path", {
  id: "bounds",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6 9l6 6 6-6"
})))));

function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var NodeIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$F({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "node"
}, /*#__PURE__*/React.createElement("path", {
  id: "bot",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-64",
  stroke: "#333",
  fill: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x: "2",
  y: "9",
  width: "19.69",
  height: "6.866",
  rx: "3.433"
})))));

function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var StoryIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$G({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "story"
}, /*#__PURE__*/React.createElement("path", {
  id: "bot",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2 3)",
  fill: "#FFF",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 2.035S3.333 0 5 0c1.667 0 5 2.035 5 2.035V18.91s-3.333-2.035-5-2.035c-1.667 0-5 2.035-5 2.035V2.035zM10 2.035S13.333 0 15 0c1.667 0 5 2.035 5 2.035V18.91s-3.333-2.035-5-2.035c-1.667 0-5 2.035-5 2.035V2.035z",
  id: "Rectangle-1670"
}))))));

function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var UploadIconIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$H({
  width: "52",
  height: "52",
  viewBox: "0 0 52 52"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 0h44a4 4 0 014 4v44a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z",
  id: "path-1",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 .5A3.5 3.5 0 00.5 4v44A3.5 3.5 0 004 51.5h44a3.5 3.5 0 003.5-3.5V4A3.5 3.5 0 0048 .5H4z",
  id: "Shape",
  stroke: "#DEDEDE"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-543",
  stroke: "#333",
  d: "M34.742 29.429v4.17H17v-4.17"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.889 30.8V19.395",
  id: "Line-175",
  stroke: "#333",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-321",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "rotate(-45 25.889 21.333)",
  d: "M23.808 19.127h4.162v4.413"
})))));

function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var TaskIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$I({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "task",
  stroke: "#24B077",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-15",
  transform: "translate(5 3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(0 1.882)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.183 30.118H0V.829h23.183v29.289z",
  id: "Rectangle-1672",
  fill: "#96F5CE",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.556 25.562H14.97",
  id: "Line",
  strokeLinecap: "square",
  transform: "matrix(1 0 0 -1 0 51.123)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.556 21.006h7.189",
  id: "Line",
  strokeLinecap: "square",
  transform: "matrix(1 0 0 -1 0 42.012)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.556 16.45h4.556",
  id: "Line",
  strokeLinecap: "square",
  transform: "matrix(1 0 0 -1 0 32.9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.556 11.243h4.556",
  id: "Line",
  strokeLinecap: "square",
  transform: "matrix(1 0 0 -1 0 22.486)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.556 5.666h4.556",
  id: "Line",
  strokeLinecap: "square",
  transform: "matrix(1 0 0 -1 0 11.331)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(14.501)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-1788",
  fill: "#FFF",
  cx: "8.031",
  cy: "7.708",
  r: "7.485"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line-401",
  transform: "scale(1 -1) rotate(-85 -.381 0)",
  d: "M5.753 11.288l4.556-4.875L8.25 4.13"
})))))));

function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var TaskGreyIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$J({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "task-grey",
  stroke: "#ACACAC"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(7 5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.804 28.716H0V2.433h20.804v26.283z",
  id: "Rectangle-1672"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.088 24.627h9.345",
  id: "Line",
  transform: "matrix(1 0 0 -1 0 49.254)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.088 20.539h6.451",
  id: "Line",
  transform: "matrix(1 0 0 -1 0 41.078)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.088 16.45h4.089",
  id: "Line",
  transform: "matrix(1 0 0 -1 0 32.901)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.088 11.778h4.089",
  id: "Line",
  transform: "matrix(1 0 0 -1 0 23.556)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.088 6.773h4.089",
  id: "Line",
  transform: "matrix(1 0 0 -1 0 13.547)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-1788",
  fill: "#FFF",
  cx: "20.22",
  cy: "6.917",
  r: "6.717"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line-401",
  transform: "scale(1 -1) rotate(-85 12.67 0)",
  d: "M18.176 10.13l4.088-4.375-1.848-2.05"
}))))));

function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var TaskboxIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$K({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "taskbox",
  stroke: "#00B0CF",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-18",
  transform: "translate(8 8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2102",
  fill: "#BDF5FF",
  strokeLinecap: "round",
  d: "M0 0h4.174v3.391H0zM0 10.174h4.174v3.391H0zM0 20.348h4.174v3.391H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.783 1.696h16.703M6.783 11.87h16.703M6.783 22.043h16.703",
  id: "Line",
  strokeLinecap: "square"
}))))));

function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var OutlierIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$L({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "outlier",
  stroke: "#C0771A",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 16h0c0 8.837-7.163 16-16 16h0C7.163 32 0 24.837 0 16h0C0 7.163 7.163 0 16 0h0c8.837 0 16 7.163 16 16z",
  id: "Rectangle-314",
  fill: "#FFBC67"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 7v12M16 24h.1",
  id: "Path-2"
}))))));

function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var BusinessIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$M({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.053 0h16.894v4.425a4.416 4.416 0 01-4.417 4.424h-8.06a4.424 4.424 0 01-4.417-4.424V0z",
  id: "path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "business"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-1501",
  stroke: "#846A59",
  strokeWidth: "2",
  fill: "#D4BBA9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M0 13.208h33v18.057H0z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-1503",
  transform: "rotate(-180 16.5 4.425)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#846A59",
  strokeWidth: "2",
  d: "M9.053 1v3.425a3.424 3.424 0 003.417 3.424h8.06c1.89 0 3.417-1.53 3.417-3.424V1H9.053z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-1501",
  stroke: "#846A59",
  strokeWidth: "2",
  fill: "#D4BBA9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M0 8.226h33v4.981H0z"
}))))));

function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var BotbreakIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$N({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "break",
  stroke: "#AB4040",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 16h0c0 8.837-7.163 16-16 16h0C7.163 32 0 24.837 0 16h0C0 7.163 7.163 0 16 0h0c8.837 0 16 7.163 16 16z",
  id: "Rectangle-314",
  fill: "#F28080"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.095 11.696L12 20.79",
  id: "Path-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.095 11.696L12 20.79",
  id: "Path-2",
  transform: "matrix(-1 0 0 1 33 0)"
}))))));

function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var BotIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$O({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "bot",
  stroke: "#5CAED9",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(8 4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 0c6.627 0 12 5.572 12 12.444V24.89C24 28.816 20.93 32 17.143 32H6.857C3.07 32 0 28.816 0 24.889V12.444C0 5.572 5.373 0 12 0z",
  id: "Rectangle-63",
  fill: "#73CFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-64",
  fill: "#FFF",
  fillRule: "nonzero",
  x: "3.429",
  y: "8.889",
  width: "17.143",
  height: "5.333",
  rx: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 19.556v7.11",
  id: "Line"
}))))));

function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var TickIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$P({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/tick",
  stroke: "#81c781"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy-4",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Oval-1-Copy-3",
  d: "M13.287 5.942l-6.095 6.367L4.56 9.81"
}))))));

function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }
var EntityEmailIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$Q({
  width: "54",
  height: "54",
  viewBox: "0 0 54 54"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/entity-type/email"
}, /*#__PURE__*/React.createElement("path", {
  id: "W",
  fill: "#333",
  d: "M9.76 31.136L5.782 7.2h2.312l2.822 19.108 3.4-19.108h2.04l3.366 19.108L22.578 7.2h2.244l-3.978 23.936h-2.21l-3.332-18.972-3.366 18.972z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.5 23.5h20M28.5 28.5h20M28.5 33.5h20M8.5 39.5h40M8.5 43.5h40M8.5 48.5h40",
  id: "Line",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))));

function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }
var ClientIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$R({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "business-permission-17",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-304 -223)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "client",
  transform: "translate(304 223)",
  stroke: "#83ACC1",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.56 34.125c-1.334-.474-3.87-1.338-6.475-2.028l-.365-2.925H14.39l-.366 2.924c-2.603.69-5.138 1.554-6.472 2.028",
  id: "Oval-1-Copy-3"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-1-Copy-2",
  cx: "20",
  cy: "20",
  r: "19"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.774 6.775c2.034 1.176 3.39 3.287 3.39 5.695 0 .295-.02.585-.059.87.273 1.112.422 2.308.425 3.554a1.09 1.09 0 011.094 1.243l-.38 2.704a1.094 1.094 0 01-1.49.861c-.488 1.417-1.186 2.656-2.036 3.634v3.836h-9.331v-3.836c-.854-.983-1.555-2.229-2.044-3.653a1.084 1.084 0 01-1.475-.854l-.376-2.682a1.081 1.081 0 011.083-1.232c0-1.253.15-2.457.424-3.575a6.34 6.34 0 01-.06-.87c0-3.343 2.615-6.113 6.028-6.604.932-.326 2.832-.935 4.033-.935.834 0 .905.93.774 1.844z",
  id: "Oval-2-Copy",
  fill: "#D5F1FF",
  fillRule: "evenodd"
})))));

function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }
var SearchIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$S({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "search",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(5 5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.5 5.5l7.649 7.649",
  id: "Line"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  fill: "#FFF",
  cx: "6",
  cy: "6",
  r: "6"
}))))));

function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }
var FilterIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$T({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/filter",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("path", {
  id: "Line",
  d: "M20.657 4l-6.988 8.741v6.429h-2.257v-6.429L4 4z"
})))));

function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }
var FilterFilledIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$U({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/filter-filled"
}, /*#__PURE__*/React.createElement("path", {
  id: "Line",
  stroke: "#21ABF3",
  fill: "#21ABF3",
  d: "M17.46 5.5l-4.885 6.035L7.4 5.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line",
  stroke: "#333",
  d: "M20.657 4l-6.988 8.741v6.429h-2.257v-6.429L4 4z"
})))));

function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }
var TransferIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$V({
  width: "22",
  height: "21",
  viewBox: "0 0 22 21"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Header",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-957 -27)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy",
  transform: "translate(946 20)",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/upload-copy",
  transform: "translate(10 6)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1 2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(12)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1.288 3.554h6.606",
  id: "Line",
  transform: "matrix(0 -1 -1 0 5.569 5.569)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-320",
  transform: "scale(-1 1) rotate(-45 0 6.784)",
  d: "M.7.67h2.567v2.654"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.443 19.11c-2.13 0-3.857-1.717-3.857-3.834s1.727-3.833 3.857-3.833h.046A4.492 4.492 0 018.944 7.61a4.503 4.503 0 014.127 2.687 4.822 4.822 0 012.624-.77c2.663 0 4.822 2.145 4.822 4.791 0 2.646-2.16 4.791-4.822 4.791-.108 0-.216-.003-.322-.01v.01H4.443z",
  id: "Oval-390"
})))))));

function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }
var EmptyBusinessPlaceholderIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$W({
  xmlns: "http://www.w3.org/2000/svg",
  width: "527",
  height: "213",
  viewBox: "0 0 527 213"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-366-2h895v247h-895z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C8C8C8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "8",
  d: "M4 125h154v84H4z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C8C8C8",
  strokeWidth: "8",
  d: "M117 100V83.5c0-9.114-7.386-16.5-16.499-16.5H62.5C53.387 67 46 74.387 46 83.5V100h71z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C8C8C8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "8",
  d: "M4 102h154v23H4zM100.053 169H62m20 19.053V150"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C8C8C8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M203.314 174.659c125.372 0 230.012-57.1 313.919-171.3m-33.065 5.644l33.899-7.206 7.15 33.638"
}))));

function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }
var RedExclamationIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$X({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#F76B6B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F76B6B",
  d: "M11 5.76l1 8.222 1-8.221zM11 17a1 1 0 002 0 1 1 0 00-2 0z"
}))));

function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }
var TickGreenIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$Y({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "9",
  fill: "#5FBE85",
  stroke: "#5FBE85"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M16.287 8.942l-6.095 6.367L7.56 12.81"
}))));

function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }
var QuestionIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$Z({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/question"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-1-Copy-2",
  stroke: "#333",
  fill: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: "12",
  cy: "12",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.415 16.225c0-.344.131-.626.395-.845.263-.218.61-.328 1.043-.328.438 0 .79.108 1.056.325.265.216.398.499.398.848s-.134.633-.402.852c-.269.219-.62.328-1.052.328-.427 0-.774-.11-1.04-.332a1.055 1.055 0 01-.398-.848zm.86-2.963c0-.282.048-.503.144-.665.097-.161.262-.302.497-.422.14-.073.349-.174.625-.305 1.027-.474 1.54-1.03 1.54-1.665 0-.48-.17-.87-.508-1.169-.339-.3-.784-.45-1.337-.45-.365 0-.7.049-1.008.145-.308.097-.495.202-.563.317a.92.92 0 00-.047.227c-.042.469-.227.703-.555.703a.501.501 0 01-.41-.187c-.102-.125-.153-.292-.153-.5v-.767c0-.287.281-.529.844-.727.563-.198 1.249-.297 2.056-.297.87 0 1.578.253 2.123.758.545.506.817 1.16.817 1.963 0 .64-.222 1.181-.665 1.622-.443.44-1.185.853-2.228 1.239v.625a.558.558 0 01-.164.419.59.59 0 01-.43.16c-.182 0-.324-.05-.426-.149-.102-.099-.152-.237-.152-.414v-.461z",
  id: "?",
  fill: "#333"
})))));

function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }
var QuestionBlueIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$_({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/question-blue"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-1-Copy-2",
  stroke: "#21ABF3",
  fill: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: "12",
  cy: "12",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.415 16.225c0-.344.131-.626.395-.845.263-.218.61-.328 1.043-.328.438 0 .79.108 1.056.325.265.216.398.499.398.848s-.134.633-.402.852c-.269.219-.62.328-1.052.328-.427 0-.774-.11-1.04-.332a1.055 1.055 0 01-.398-.848zm.86-2.963c0-.282.048-.503.144-.665.097-.161.262-.302.497-.422.14-.073.349-.174.625-.305 1.027-.474 1.54-1.03 1.54-1.665 0-.48-.17-.87-.508-1.169-.339-.3-.784-.45-1.337-.45-.365 0-.7.049-1.008.145-.308.097-.495.202-.563.317a.92.92 0 00-.047.227c-.042.469-.227.703-.555.703a.501.501 0 01-.41-.187c-.102-.125-.153-.292-.153-.5v-.767c0-.287.281-.529.844-.727.563-.198 1.249-.297 2.056-.297.87 0 1.578.253 2.123.758.545.506.817 1.16.817 1.963 0 .64-.222 1.181-.665 1.622-.443.44-1.185.853-2.228 1.239v.625a.558.558 0 01-.164.419.59.59 0 01-.43.16c-.182 0-.324-.05-.426-.149-.102-.099-.152-.237-.152-.414v-.461z",
  id: "?",
  fill: "#21ABF3"
})))));

function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }
var QuestionBookIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$$({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon/question-book",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(5 2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-1670",
  stroke: "#333",
  fill: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M0 0h11.066L15 4.443v15.52H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11 0v4.243h3.84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.205 9.829c0-.153.059-.278.176-.375a.701.701 0 01.463-.146.72.72 0 01.469.144.462.462 0 01.177.377c0 .155-.06.28-.18.378a.715.715 0 01-.466.146.697.697 0 01-.462-.148.469.469 0 01-.177-.376zm.184-2.32c0-.22.037-.394.113-.52.075-.127.205-.237.388-.33.11-.058.274-.137.49-.24.803-.37 1.205-.805 1.205-1.302 0-.375-.133-.68-.398-.915-.265-.234-.613-.352-1.046-.352-.285 0-.548.038-.789.114-.24.075-.387.158-.44.247a.72.72 0 00-.037.178c-.033.367-.178.55-.435.55a.392.392 0 01-.32-.146A.602.602 0 012 4.4v-.6c0-.224.22-.414.66-.569C3.102 3.077 3.639 3 4.27 3c.68 0 1.234.198 1.66.593.427.396.64.908.64 1.536 0 .502-.173.925-.52 1.27-.347.344-.928.667-1.744.97v.489a.437.437 0 01-.128.327.461.461 0 01-.337.125.458.458 0 01-.333-.116.432.432 0 01-.12-.324v-.361z",
  id: "?",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 13h2M3 15h9M3 17h9",
  id: "Line-2",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))));

function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }
var ArrowIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$10({
  width: "100pt",
  height: "100pt",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M63.156 28.5l-3 2.852c-.79.746-.79 2.168 0 2.914L72.445 45.98H14.312c-.984.093-1.816 1.015-1.813 2.004v4.007c0 1.051.954 2.004 2 2.004h57.945c-4.16 3.961-8.187 7.809-12.289 11.715-.789.746-.789 2.168 0 2.914l3 2.852c.735.695 2.016.695 2.75 0 6.012-5.73 15.004-14.32 21.012-20.047.77-.746.77-2.137 0-2.883L65.905 28.5c-1.019-.789-1.816-.535-2.75 0z"
})));

function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }
var TestBotIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$11({
  width: "100pt",
  height: "100pt",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M49.258 70H90V13.332H10V70h23.332v16.461zm-1.414-3.332h38.824v-50H13.332v50h23.336v11.555z",
  fillRule: "evenodd"
})));

function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }
var SubstoryEmptyIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$12({
  width: "101",
  height: "121",
  viewBox: "0 0 101 121",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-36.1%",
  y: "-32.8%",
  width: "172.1%",
  height: "172.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: "2",
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "7",
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.52587183 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  fill: "#000",
  opacity: ".645"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.326 7.291c1.042 0 1.953.91 1.953 1.953 0 1.043-.91 1.953-1.953 1.953H7.706c-1.043 0-1.953-.91-1.953-1.953 0-1.042.91-1.953 1.953-1.953h62.62zM49.367 91.916c0 .651-.132 1.302-.132 1.953 0 .65 0 1.302.132 1.953H13.432c-7.16 0-12.887-6.77-12.887-14.972V9.244c0-4.689 3.387-8.462 7.42-8.462H73.97c1.042 0 1.953.91 1.953 1.952 0 1.043-.91 1.953-1.953 1.953H7.965c-1.953 0-3.514 2.085-3.514 4.557 0 2.472 1.56 4.557 3.514 4.557h66.139c1.042 0 1.953.91 1.953 1.953v53.511c-.651 0-1.302-.132-1.953-.132s-1.302 0-1.953.132V17.707H7.965c-1.302 0-2.472-.392-3.514-1.043V80.85c0 6.118 4.038 11.066 8.98 11.066h35.936z",
  id: "Fill-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  filter: "url(#filter-1)",
  transform: "translate(27 44.207)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.64.948C15.392.948 2.806 12.37.979 27.126a30.087 30.087 0 00-.23 3.715c0 16.51 13.383 29.89 29.89 29.89 16.51 0 29.893-13.38 29.893-29.89.003-12.567-7.752-23.322-18.738-27.745A29.785 29.785 0 0030.641.948z",
  id: "Page-1",
  fill: "#9C9C9C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.64 6.2c-12.57 0-22.944 9.416-24.45 21.578A24.8 24.8 0 006 30.841c0 13.61 11.031 24.638 24.638 24.638 13.61 0 24.64-11.029 24.64-24.638.003-10.36-6.39-19.225-15.445-22.87a24.552 24.552 0 00-9.192-1.77z",
  id: "Page-1",
  stroke: "#2D2D2D",
  strokeWidth: "3",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.6 31.803v9.72a.96.96 0 01-1.919 0v-9.72h-9.72a.96.96 0 010-1.919h9.72v-9.722a.96.96 0 011.919 0v9.72l9.72.002a.96.96 0 010 1.919H31.6z",
  id: "Path",
  fill: "#000"
}))))));

function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }
var QuotesOpenIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$13({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M7.296 11.937h.278c.755 0 1.433.288 2.036.864.602.576.903 1.294.903 2.154 0 .848-.301 1.546-.903 2.095-.603.55-1.347.824-2.234.824-.967 0-1.77-.387-2.413-1.161C4.321 15.938 4 14.836 4 13.407c0-1.311.281-2.539.844-3.684s1.25-2.052 2.065-2.72C7.723 6.334 8.448 6 9.083 6c.424 0 .755.126.993.377.238.252.358.576.358.973 0 .583-.259 1.013-.775 1.291-.701.384-1.257.834-1.668 1.35-.41.516-.642 1.165-.695 1.946zm8.777 0h.258c.741 0 1.413.288 2.016.864.602.576.903 1.294.903 2.154 0 .834-.301 1.536-.903 2.105-.603.57-1.347.854-2.234.854-.98 0-1.787-.397-2.423-1.191-.635-.795-.953-1.9-.953-3.316 0-1.02.165-1.98.496-2.88.331-.9.758-1.684 1.281-2.353.523-.668 1.086-1.198 1.688-1.588.602-.39 1.142-.586 1.618-.586.437 0 .771.122 1.003.367.232.245.348.573.348.983 0 .596-.259 1.026-.775 1.291-.728.41-1.277.864-1.648 1.36-.37.497-.596 1.142-.675 1.936z"
})));

function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }
var QuotesCloseIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$14({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M7.296 11.937h.278c.755 0 1.433.288 2.036.864.602.576.903 1.294.903 2.154 0 .848-.301 1.546-.903 2.095-.603.55-1.347.824-2.234.824-.967 0-1.77-.387-2.413-1.161C4.321 15.938 4 14.836 4 13.407c0-1.311.281-2.539.844-3.684s1.25-2.052 2.065-2.72C7.723 6.334 8.448 6 9.083 6c.424 0 .755.126.993.377.238.252.358.576.358.973 0 .583-.259 1.013-.775 1.291-.701.384-1.257.834-1.668 1.35-.41.516-.642 1.165-.695 1.946zm8.777 0h.258c.741 0 1.413.288 2.016.864.602.576.903 1.294.903 2.154 0 .834-.301 1.536-.903 2.105-.603.57-1.347.854-2.234.854-.98 0-1.787-.397-2.423-1.191-.635-.795-.953-1.9-.953-3.316 0-1.02.165-1.98.496-2.88.331-.9.758-1.684 1.281-2.353.523-.668 1.086-1.198 1.688-1.588.602-.39 1.142-.586 1.618-.586.437 0 .771.122 1.003.367.232.245.348.573.348.983 0 .596-.259 1.026-.775 1.291-.728.41-1.277.864-1.648 1.36-.37.497-.596 1.142-.675 1.936z"
})));

function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }
var TemplateIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$15({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("rect", {
  width: "6",
  height: "6",
  x: "4",
  y: "4",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  width: "6",
  height: "6",
  x: "14",
  y: "4",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  width: "6",
  height: "6",
  x: "4",
  y: "14",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  width: "6",
  height: "6",
  x: "14",
  y: "14",
  rx: "1"
}))));

function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }
var TemplateGeneralIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$16({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon/template/general",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4 4)",
  stroke: "#30B89F"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-593",
  strokeLinecap: "round",
  cx: "8",
  cy: "8",
  r: "8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 15.294V0",
  id: "Line-197",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.53 8H.47",
  id: "Line-198",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-594",
  strokeLinecap: "round",
  cx: "8",
  cy: "8.235",
  rx: "4.706",
  ry: "7.765"
})))));

function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }
var TemplateSubstoryIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$17({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon/template/sub-story",
  stroke: "#3A9ACB",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-670",
  d: "M5.207 15.552V7.379H8.93"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-670",
  transform: "matrix(-1 0 0 1 33.862 0)",
  d: "M15.069 15.552V7.379h3.724"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-664",
  d: "M9.086 5.5h5.828v3.759H9.086zM2.293 15.707h5.828v3.759H2.293z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-665",
  d: "M15.879 15.707h5.828v3.759h-5.828z"
}))));

function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }
var TemplateSubstoryApiIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$18({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon/template/sub-story-with-api",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  fill: "#FE2F2F",
  cx: "22",
  cy: "2",
  r: "2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-670",
  stroke: "#3A9ACB",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M5.207 15.552V7.379H8.93"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-670",
  stroke: "#3A9ACB",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "matrix(-1 0 0 1 33.862 0)",
  d: "M15.069 15.552V7.379h3.724"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-664",
  stroke: "#3A9ACB",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.086 5.5h5.828v3.759H9.086zM2.293 15.707h5.828v3.759H2.293z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-665",
  stroke: "#3A9ACB",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M15.879 15.707h5.828v3.759h-5.828z"
}))));

function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }
var CircleMoreIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$19({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon/circle-more",
  stroke: "none",
  strokeWidth: "1",
  fill: "#333",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.5 12a8.5 8.5 0 10-17 0 8.5 8.5 0 0017 0zm1 0a9.5 9.5 0 11-19 0 9.5 9.5 0 0119 0z",
  id: "Rectangle-314",
  fillRule: "nonzero",
  transform: "rotate(90 12 12)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 12a1 1 0 01-2 0 1 1 0 012 0z",
  id: "Rectangle-314",
  transform: "rotate(90 8 12)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 12a1 1 0 01-2 0 1 1 0 012 0z",
  id: "Rectangle-314",
  transform: "rotate(90 12 12)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 12a1 1 0 01-2 0 1 1 0 012 0z",
  id: "Rectangle-314",
  transform: "rotate(90 16 12)"
}))));

function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }
var PasteIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1a({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "sub-story",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(5 2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-1670",
  fill: "#FFF",
  d: "M0 0h11.066L15 4.443v15.52H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line",
  d: "M11 0v4.243h3.84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 5.5h5M2.5 8.5h9M2.5 5.5h5M2.5 11.5h9M2.5 14.5h9",
  id: "Line-2"
}))))));

function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }
var HaptikIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1b({
  width: "697",
  height: "732",
  viewBox: "0 0 697 732",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M286 3c-23 10-24 58-24 58v43c1 43 0 47-1 95 0 26-2 71 0 98 1 12-17 18-21 2-9-31-17-71-19-81l-12-71c-11-56-15-61-22-76-25-50-61-9-58 21 3 24 17 112 37 197 6 29 10 75-2 80-18 6-24-6-40-32l-45-81c-13-22-36-70-66-60-19 6-19 30 21 100 41 73 52 118 68 163 15 44 28 101 49 158 14 40 38 88 78 105 55 23 91 1 139-22 36-16 77-56 103-87 35-40 45-56 86-91 35-30 67-50 107-74 38-22 41-46 20-58-27-16-84 2-120 31-38 32-104 86-136 22-11-21-14-28-16-49-4-27 3-46 5-54 4-13 11-23 16-40 17-56 28-112 39-170 10-55 3-82-20-86-18-3-31 12-42 45-21 63-14 102-30 166-5 17-11 60-35 58-17-2-26-20-22-72 3-39-3-111 0-148 2-34-4-94-29-92l-8 2",
  id: "path-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-3",
  d: "M0 0h4519v2573H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M294 0l-8 3c-23 9-24 57-24 57v138c-1 26-2 72 0 99 0 12-18 18-22 2l-19-81-12-72c-11-55-15-61-22-75-24-50-60-10-57 20 2 25 16 112 36 197 6 29 11 76-2 81-17 6-23-6-40-33-13-21-32-59-45-80-13-23-35-71-66-61-18 6-19 30 21 101 41 73 53 118 68 163 15 44 28 101 49 158 15 40 38 88 78 105 55 23 91 0 139-22 36-16 77-56 103-87 35-40 45-56 86-91 35-31 66-50 107-74 38-22 40-46 20-58-27-17-84 2-120 31-39 32-104 86-136 22-11-21-14-28-16-49-4-27 3-46 5-54 4-13 11-24 16-40 17-56 28-113 39-171 10-55 3-81-20-85-18-4-31 11-42 45-21 62-14 101-30 165-5 18-11 61-35 59-17-2-26-21-22-72 3-39-2-111 0-148 2-34-4-93-27-93h-2",
  id: "path-5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-7",
  d: "M0 0h4519v2573H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-9",
  d: "M0 0h494v782H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M451 0s74 264-21 479c-54 122-177 205-320 301L0 515s286-44 334-459",
  id: "path-11"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-13",
  d: "M0 0h704v731H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M294 0l-8 3c-23 9-24 57-24 57v138c-1 26-2 72 0 99 0 12-18 18-22 2l-19-81-12-72c-11-55-15-61-22-75-24-50-60-10-57 20 2 25 16 112 36 197 6 29 11 76-2 81-17 6-23-6-40-33-13-21-32-59-45-80-13-23-35-71-66-61-18 6-19 30 21 101 41 73 53 118 68 163 15 44 28 101 49 158 15 40 38 88 78 105 55 23 91 0 139-22 36-16 77-56 103-87 35-40 45-56 86-91 35-31 66-50 107-74 38-22 40-46 20-58-27-17-84 2-120 31-39 32-104 86-136 22-11-21-14-28-16-49-4-27 3-46 5-54 4-13 11-24 16-40 17-56 28-113 39-171 10-55 3-81-20-85-18-4-31 11-42 45-21 62-14 101-30 165-5 18-11 61-35 59-17-2-26-21-22-72 3-39-2-111 0-148 2-34-4-93-27-93h-2",
  id: "path-15"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-17",
  d: "M0 0h4519v2573H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-19",
  d: "M0 0h569v603H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 601s472-25 567-481L406 0s90 351-384 465c-22 5 1 128-22 136",
  id: "path-21"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-23",
  d: "M0 0h704v731H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M294 0l-8 3c-23 9-24 57-24 57v138c-1 26-2 72 0 99 0 12-18 18-22 2l-19-81-12-72c-11-55-15-61-22-75-24-50-60-10-57 20 2 25 16 112 36 197 6 29 11 76-2 81-17 6-23-6-40-33-13-21-32-59-45-80-13-23-35-71-66-61-18 6-19 30 21 101 41 73 53 118 68 163 15 44 28 101 49 158 15 40 38 88 78 105 55 23 91 0 139-22 36-16 77-56 103-87 35-40 45-56 86-91 35-31 66-50 107-74 38-22 40-46 20-58-27-17-84 2-120 31-39 32-104 86-136 22-11-21-14-28-16-49-4-27 3-46 5-54 4-13 11-24 16-40 17-56 28-113 39-171 10-55 3-81-20-85-18-4-31 11-42 45-21 62-14 101-30 165-5 18-11 61-35 59-17-2-26-21-22-72 3-39-2-111 0-148 2-34-4-93-27-93h-2",
  id: "path-25"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-27",
  d: "M0 0h4519v2573H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-29",
  d: "M0 0h367v218H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M364 0S231 298 0 171c0 0 202 18 364-171",
  id: "path-31"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-33",
  d: "M0 0h704v731H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M294 0l-8 3c-23 9-24 57-24 57v138c-1 26-2 72 0 99 0 12-18 18-22 2l-19-81-12-72c-11-55-15-61-22-75-24-50-60-10-57 20 2 25 16 112 36 197 6 29 11 76-2 81-17 6-23-6-40-33-13-21-32-59-45-80-13-23-35-71-66-61-18 6-19 30 21 101 41 73 53 118 68 163 15 44 28 101 49 158 15 40 38 88 78 105 55 23 91 0 139-22 36-16 77-56 103-87 35-40 45-56 86-91 35-31 66-50 107-74 38-22 40-46 20-58-27-17-84 2-120 31-39 32-104 86-136 22-11-21-14-28-16-49-4-27 3-46 5-54 4-13 11-24 16-40 17-56 28-113 39-171 10-55 3-81-20-85-18-4-31 11-42 45-21 62-14 101-30 165-5 18-11 61-35 59-17-2-26-21-22-72 3-39-2-111 0-148 2-34-4-93-27-93h-2",
  id: "path-35"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-37",
  d: "M0 0h4519v2573H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-39",
  d: "M0 0h112v168H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91 0s31 148-91 164c0 0 81-49 91-164",
  id: "path-41"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-43",
  d: "M0 0h704v731H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M294 0l-8 3c-23 9-24 57-24 57v138c-1 26-2 72 0 99 0 12-18 18-22 2l-19-81-12-72c-11-55-15-61-22-75-24-50-60-10-57 20 2 25 16 112 36 197 6 29 11 76-2 81-17 6-23-6-40-33-13-21-32-59-45-80-13-23-35-71-66-61-18 6-19 30 21 101 41 73 53 118 68 163 15 44 28 101 49 158 15 40 38 88 78 105 55 23 91 0 139-22 36-16 77-56 103-87 35-40 45-56 86-91 35-31 66-50 107-74 38-22 40-46 20-58-27-17-84 2-120 31-39 32-104 86-136 22-11-21-14-28-16-49-4-27 3-46 5-54 4-13 11-24 16-40 17-56 28-113 39-171 10-55 3-81-20-85-18-4-31 11-42 45-21 62-14 101-30 165-5 18-11 61-35 59-17-2-26-21-22-72 3-39-2-111 0-148 2-34-4-93-27-93h-2",
  id: "path-45"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-47",
  d: "M0 0h4519v2573H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-49",
  d: "M0 0h433v234H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 97S165 245 432 0c0 0-251 419-432 97",
  id: "path-51"
}), /*#__PURE__*/React.createElement("path", {
  id: "path-53",
  d: "M0 0h704v731H0z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1369 -922)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  stroke: "none",
  fill: "#51CFE1",
  fillRule: "nonzero",
  mask: "url(#mask-4)",
  d: "M1356 909h723v758h-723z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  mask: "url(#mask-6)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1369 -922)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-7"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-8)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1391 822)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-10",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-9"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-10)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-12",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-11"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-12)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-22 100)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-14",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-13"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  stroke: "none",
  fill: "#0067DD",
  fillRule: "nonzero",
  mask: "url(#mask-14)",
  d: "M9-113h505v807H9z"
}))))))))), /*#__PURE__*/React.createElement("mask", {
  id: "mask-16",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-15"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  mask: "url(#mask-16)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1369 -922)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-18",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-17"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-18)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1433 1096)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-20",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-19"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-20)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-22",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-21"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-22)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-65 -173)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-24",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-23"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  stroke: "none",
  fill: "#F8059F",
  fillRule: "nonzero",
  mask: "url(#mask-24)",
  d: "M52 159h594v628H52z"
}))))))))), /*#__PURE__*/React.createElement("mask", {
  id: "mask-26",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-25"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  mask: "url(#mask-26)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1369 -922)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-28",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-27"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-28)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1292 1287)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-30",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-29"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-30)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-32",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-31"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-32)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(75 -364)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-34",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-33"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  stroke: "none",
  fill: "#FFF300",
  fillRule: "nonzero",
  mask: "url(#mask-34)",
  d: "M-88 351h390v229H-88z"
}))))))))), /*#__PURE__*/React.createElement("mask", {
  id: "mask-36",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-35"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  mask: "url(#mask-36)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1369 -922)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-38",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-37"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-38)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1627 1098)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-40",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-39"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-40)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 3)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-42",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-41"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-42)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-260 -178)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-44",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-43"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  stroke: "none",
  fill: "#FFCB00",
  fillRule: "nonzero",
  mask: "url(#mask-44)",
  d: "M247 165h121v191H247z"
}))))))))), /*#__PURE__*/React.createElement("mask", {
  id: "mask-46",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-45"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  mask: "url(#mask-46)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1369 -922)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-48",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-47"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-48)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1369 1340)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-50",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-49"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-52",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-51"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  mask: "url(#mask-52)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1 -418)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-54",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-53"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  stroke: "none",
  fill: "#FFF400",
  fillRule: "nonzero",
  mask: "url(#mask-54)",
  d: "M-12 405h458v245H-12z"
})))))))))))));

function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }
var ProfileIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1c({
  width: "100pt",
  height: "100pt",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M64.934 12.852A39.808 39.808 0 0050 9.973c-20.172 0-37.246 15.07-39.723 35.06a40.465 40.465 0 00-.305 4.972c0 22.07 17.957 40.027 40.027 40.027 7.98 0 15.414-2.356 21.664-6.395.223-.078.426-.203.582-.375 10.72-7.191 17.785-19.414 17.785-33.258-.004-16.438-9.851-31.023-25.098-37.152zM50 87.028a36.808 36.808 0 01-19.699-5.7c.023-.105.04-.214.04-.323 0-1.07.1-3.2.26-4.098C32.427 66.782 43.54 65.27 50 65.27c5.465 0 18.312 1.246 19.566 12.777.023.238.054 1.558.078 3.32a36.782 36.782 0 01-19.645 5.66zm22.609-7.73c-.02-.758-.035-1.36-.062-1.57C71.492 68.047 63.062 62.27 50 62.27c-12.773 0-20.711 5.012-22.355 14.11-.13.734-.215 1.886-.262 2.91-8.758-6.778-14.414-17.384-14.414-29.286 0-1.543.094-3.093.285-4.605C15.543 26.91 31.34 12.973 50 12.973c4.777 0 9.426.894 13.812 2.66C77.914 21.305 87.027 34.797 87.027 50c0 11.91-5.656 22.52-14.418 29.297zM50 29.472c-7.363 0-12.508 5.493-12.508 13.353 0 8.296 5.61 15.047 12.508 15.047 6.894 0 12.508-6.75 12.508-15.047 0-7.86-5.145-13.352-12.508-13.352zm0 25.396c-5.242 0-9.508-5.403-9.508-12.048 0-6.19 3.82-10.351 9.508-10.351s9.508 4.16 9.508 10.351c0 6.645-4.266 12.048-9.508 12.048z"
})));

function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }
var PlaceholderIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1d({
  width: "53",
  height: "45",
  viewBox: "0 0 53 45",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Chat-Elements",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "mockup-25",
  transform: "translate(-229 -391)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(62 80)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(70 263)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(97 48)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-166",
  fill: "#82959E",
  x: "0",
  y: "0",
  width: "53",
  height: "45",
  rx: "2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-167-Copy",
  fill: "#D5F1FF",
  d: "M48 24.207V6H5v14.557"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 24.207V32H5V20.557c2.723-.91 5.76-1.668 9-2.057C26.5 17 29 21 38.5 23c2.855.601 6.208.976 9.5 1.207z",
  id: "Rectangle-167",
  fill: "#28CF82"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-84",
  fill: "#F98431",
  cx: "40",
  cy: "13",
  r: "3"
})))))))));

function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }
var PlaceholderIcon$1 = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1e({
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.525 7.082L9.029 12.58a2.046 2.046 0 002.892 2.892l6.075-6.074a3.272 3.272 0 10-4.628-4.629L6.136 12c-1.759 1.759-1.759 4.605 0 6.364s4.605 1.759 6.364 0l6.653-6.653",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }
var BotTabIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1f({
  width: "21",
  height: "26",
  viewBox: "0 0 21 26",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Final-Screens",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "mockup-05",
  transform: "translate(-107 -108)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components/Tabs",
  transform: "translate(60 105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/Bot/outline",
  transform: "translate(41)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.444 3.111c5.404 0 9.778 4.536 9.778 10.124v9.679c0 3.296-2.583 5.975-5.778 5.975h-8c-3.194 0-5.777-2.679-5.777-5.975v-9.68c0-5.587 4.374-10.123 9.777-10.123z",
  id: "Path",
  fill: "#333",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.444 4c-4.905 0-8.888 4.13-8.888 9.235v9.679c0 2.812 2.192 5.086 4.888 5.086h8c2.697 0 4.89-2.274 4.89-5.086v-9.68C25.333 8.132 21.35 4 16.443 4z",
  id: "Path",
  fill: "#FFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.111 10.025h10.667c.982 0 1.778.796 1.778 1.777v1.482c0 .982-.796 1.778-1.778 1.778H11.11a1.778 1.778 0 01-1.778-1.778v-1.482c0-.981.796-1.777 1.778-1.777z",
  id: "Path",
  fill: "#333",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.111 10.914a.889.889 0 00-.889.888v1.482c0 .49.398.889.89.889h10.666c.49 0 .889-.398.889-.889v-1.482a.889.889 0 00-.89-.888H11.112z",
  id: "Path",
  fill: "#DDD",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line",
  fill: "#333",
  fillRule: "nonzero",
  d: "M16 18.765h.889v5.531H16z"
})))))));

function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }
var BotTabColoredIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1g({
  width: "21",
  height: "26",
  viewBox: "0 0 21 26",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Final-Screens",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "mockup-03",
  transform: "translate(-107 -108)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components/Tabs",
  transform: "translate(60 105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/Bot/colored",
  transform: "translate(41)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.444 3.111c5.404 0 9.778 4.536 9.778 10.124v9.679c0 3.296-2.583 5.975-5.778 5.975h-8c-3.194 0-5.777-2.679-5.777-5.975v-9.68c0-5.587 4.374-10.123 9.777-10.123z",
  id: "Path",
  fill: "#5CAED9",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.444 4c-4.905 0-8.888 4.13-8.888 9.235v9.679c0 2.812 2.192 5.086 4.888 5.086h8c2.697 0 4.89-2.274 4.89-5.086v-9.68C25.333 8.132 21.35 4 16.443 4z",
  id: "Path",
  fill: "#85D6FF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.111 10.025h10.667c.982 0 1.778.796 1.778 1.777v1.482c0 .982-.796 1.778-1.778 1.778H11.11a1.778 1.778 0 01-1.778-1.778v-1.482c0-.981.796-1.777 1.778-1.777z",
  id: "Path",
  fill: "#5CAED9",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.111 10.914a.889.889 0 00-.889.888v1.482c0 .49.398.889.89.889h10.666c.49 0 .889-.398.889-.889v-1.482a.889.889 0 00-.89-.888H11.112z",
  id: "Path",
  fill: "#FFF",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line",
  fill: "#5CAED9",
  fillRule: "nonzero",
  d: "M16 18.765h.889v5.531H16z"
})))))));

function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }
var TemplateTabIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1h({
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Final-Screens",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "mockup-03",
  transform: "translate(-232 -110)",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components/Tabs",
  transform: "translate(60 105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/template/outline",
  transform: "translate(167)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2114",
  fill: "#FFF",
  x: "6.222",
  y: "6.222",
  width: "7.333",
  height: "7.333",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2114",
  fill: "#DDD",
  x: "18.444",
  y: "6.222",
  width: "7.333",
  height: "7.333",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2114",
  fill: "#DDD",
  x: "6.222",
  y: "18.444",
  width: "7.333",
  height: "7.333",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2114",
  fill: "#DDD",
  x: "18.444",
  y: "18.444",
  width: "7.333",
  height: "7.333",
  rx: "1"
})))))));

function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }
var TemplateTabColoredIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1i({
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Final-Screens",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "mockup-05",
  transform: "translate(-232 -110)",
  fill: "#FFC985",
  stroke: "#FF9106"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components/Tabs",
  transform: "translate(60 105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/template/colored",
  transform: "translate(167)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2114",
  x: "6.222",
  y: "6.222",
  width: "7.333",
  height: "7.333",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2114",
  x: "18.444",
  y: "6.222",
  width: "7.333",
  height: "7.333",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2114",
  x: "6.222",
  y: "18.444",
  width: "7.333",
  height: "7.333",
  rx: "1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2114",
  x: "18.444",
  y: "18.444",
  width: "7.333",
  height: "7.333",
  rx: "1"
})))))));

function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }
var BusinessTabIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1j({
  width: "27",
  height: "26",
  viewBox: "0 0 27 26",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Final-Screens",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "mockup-03",
  transform: "translate(-361 -108)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components/Tabs",
  transform: "translate(60 105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/business-disabled",
  transform: "translate(298)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-1501",
  stroke: "#333",
  fill: "#DDD",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.556 13.873h25.778v14.105H3.556z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.838 5.618v2.175c0 1.199.978 2.175 2.183 2.175h4.847c1.212 0 2.183-.97 2.183-2.175V5.618h-9.213z",
  id: "Rectangle-1503",
  stroke: "#6A5343",
  transform: "rotate(-180 16.444 7.793)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.346 4.056v2.956a2.956 2.956 0 002.95 2.956h6.297a2.95 2.95 0 002.95-2.956V4.056H10.346z",
  id: "Rectangle-1503",
  stroke: "#333",
  fill: "#FFF",
  fillRule: "evenodd",
  transform: "rotate(-180 16.444 7.012)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-1501",
  stroke: "#333",
  fill: "#FFF",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.556 9.982h25.778v3.891H3.556z"
})))))));

function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }
var BusinessTabColoredIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1k({
  width: "27",
  height: "26",
  viewBox: "0 0 27 26",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Final-Screens",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "mockup-06",
  transform: "translate(-361 -108)",
  stroke: "#664B39"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components/Tabs",
  transform: "translate(60 105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "image/business",
  transform: "translate(298)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-1501",
  fill: "#8C6C56",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.556 13.873h25.778v14.105H3.556z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.838 5.618v2.175c0 1.199.978 2.175 2.183 2.175h4.847c1.212 0 2.183-.97 2.183-2.175V5.618h-9.213z",
  id: "Rectangle-1503",
  transform: "rotate(-180 16.444 7.793)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.346 4.056v2.956a2.956 2.956 0 002.95 2.956h6.297a2.95 2.95 0 002.95-2.956V4.056H10.346z",
  id: "Rectangle-1503",
  fill: "#FFF",
  fillRule: "evenodd",
  transform: "rotate(-180 16.444 7.012)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-1501",
  fill: "#D7AB8C",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.556 9.982h25.778v3.891H3.556z"
})))))));

function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }
var GridIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1l({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon/grid",
  stroke: "#333",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2105",
  d: "M3 3h3.6v3.6H3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2106",
  d: "M10.2 3h3.6v3.6h-3.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2107",
  d: "M17.4 3H21v3.6h-3.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2110",
  d: "M3 10.2h3.6v3.6H3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2108",
  d: "M10.2 10.2h3.6v3.6h-3.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2109",
  d: "M17.4 10.2H21v3.6h-3.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2113",
  d: "M3 17.4h3.6V21H3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2111",
  d: "M10.2 17.4h3.6V21h-3.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-2112",
  d: "M17.4 17.4H21V21h-3.6z"
}))));

function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }
var AnalyticsIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1m({
  width: "90",
  height: "62",
  viewBox: "0 0 90 62",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "analytics",
  d: "M79.398.102c-5.7 0-10.301 4.602-10.301 10.301 0 3.602 1.898 6.8 4.8 8.7L62.5 33.7c-1-.3-2.102-.5-3.2-.5-1.398 0-2.8.301-4 .801l-14.3-9.3c1.199-1.7 2-3.802 2-6C43 13 38.398 8.398 32.699 8.398c-5.7 0-10.301 4.602-10.301 10.301 0 3.301 1.601 6.301 4.101 8.2L15.101 42.5c-1.398-.699-2.898-1.101-4.601-1.101C4.898 41.4.3 46 .3 51.7c0 5.7 4.602 10.302 10.302 10.302 5.699 0 10.3-4.602 10.3-10.301 0-2.602-1-4.899-2.5-6.7l11.802-16.397c.8.199 1.601.3 2.5.3 1.898 0 3.699-.5 5.199-1.398l13.898 9c-1.7 1.8-2.7 4.3-2.7 7 0 5.7 4.602 10.301 10.302 10.301 5.699 0 10.3-4.602 10.3-10.301 0-3.102-1.398-5.898-3.5-7.7l11.899-15.198c.5.101 1 .101 1.601.101 5.7 0 10.301-4.601 10.301-10.3C90 4.7 85.102.102 79.4.102l-.001-.001zM10.601 57.899c-3.5 0-6.3-2.8-6.3-6.3s2.8-6.302 6.3-6.302c1.3 0 2.5.399 3.398 1 .102.2.301.301.399.399.101.101.2.101.3.2 1.301 1.1 2 2.8 2 4.6C16.8 55.103 14 57.9 10.602 57.9zM26.3 18.602c0-3.5 2.8-6.3 6.3-6.3s6.302 2.8 6.302 6.3-2.801 6.3-6.301 6.3c-3.5-.003-6.301-2.8-6.301-6.3zM59.198 49.7c-3.5 0-6.3-2.8-6.3-6.3s2.8-6.302 6.3-6.302 6.3 2.801 6.3 6.301-2.8 6.301-6.3 6.301zm20.199-33.098c-3.5 0-6.3-2.8-6.3-6.3S75.896 4 79.396 4s6.3 2.801 6.3 6.301-2.8 6.301-6.3 6.301z",
  fill: "#000",
  fillRule: "nonzero"
})));

function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }
var ExpandIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1n({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.1 6.323a.9.9 0 01.9-.9h8.1a.9.9 0 110 1.8H8.173L17.1 16.15v-5.927a.9.9 0 011.8 0v8.1a.9.9 0 01-.9.9H9.9a.9.9 0 010-1.8h5.927L6.9 8.496v5.927a.9.9 0 01-1.8 0v-8.1z",
  fill: "#000"
})));

function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }
var ExpandThinIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1o({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.957.42c.045.108.05.224.036.34v5.809a.678.678 0 11-1.356 0V2.332l-4.665 4.66a.679.679 0 01-.959-.96l4.68-4.676H9.435a.677.677 0 110-1.356h5.894l.008.002c.086.001.17.017.252.05a.686.686 0 01.367.367zM6.572 14.642a.678.678 0 110 1.357H.68A.684.684 0 010 15.324v-.002c0-.027.012-.054.016-.082V9.431a.679.679 0 011.357 0v4.237L6.04 9.004a.68.68 0 01.96.96l-4.683 4.68h4.255z",
  fill: "#333"
})));

function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }
var ShrinkIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1p({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.728 13.243v1.994l-6.484.007-.007 6.484h-1.994v-8.485h8.485zM1.997 11.482V9.488l6.484-.007.007-6.484h1.994v8.485H1.997z",
  fill: "#000",
  fillOpacity: ".87"
})));

function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }
var DownloadIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1q({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  stroke: "#333",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15 11.25v3H3v-3M9 3.75v7.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.75 9.75L8.934 12l2.316-2.25",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.75 9.75L8.934 12l2.316-2.25",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }
var PlusCalendar = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1r({
  width: "14",
  height: "15",
  viewBox: "0 0 14 15",
  fill: "#333",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.93 2.143c.305 0 .545.108.763.325.217.216.326.454.304.757v10.693c0 .303-.109.54-.326.757a1.059 1.059 0 01-.762.325H1.089c-.305 0-.545-.108-.762-.325A1.047 1.047 0 010 13.918V3.225c0-.303.109-.541.327-.757a1.06 1.06 0 01.761-.325h1.067v-.801c0-.368.13-.693.392-.952.283-.26.588-.39.958-.39h.544c.37 0 .697.13.958.39.261.281.392.584.392.952v.8H8.62v-.8c0-.368.131-.693.392-.952C9.295.13 9.6 0 9.97 0h.544c.37 0 .697.13.958.39.261.281.392.584.392.952v.8h1.067zm-2.154-.52H9.709V3.29h1.067V1.623zm-7.51 0h1.066V3.29H3.265V1.623zM1.11 13.896h11.82v-8.55H1.11v8.55z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.532 8.918h1.807c.065 0 .13.021.174.065a.245.245 0 01.065.173v.52c0 .064-.022.13-.065.194-.044.065-.109.065-.174.065H7.532v1.797c0 .065-.022.13-.065.173-.044.043-.11.065-.196.065h-.523a.352.352 0 01-.196-.065c-.065-.043-.065-.108-.065-.173V9.935H4.68a.352.352 0 01-.196-.065c-.065-.043-.065-.108-.065-.195v-.52c0-.064.022-.129.065-.172.044-.044.11-.065.196-.065h1.807V7.12c0-.065.022-.13.065-.195.044-.065.11-.065.196-.065h.523c.065 0 .13.022.196.065.065.044.065.109.065.195v1.797z"
})));

function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }
var CaretUp = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1s({
  width: "14",
  height: "7",
  viewBox: "0 0 14 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14 7L7 0 0 7h14z",
  fill: "#858585"
})));

function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }
var CaretDown = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1t({
  width: "14",
  height: "7",
  viewBox: "0 0 14 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0l7 7 7-7H0z",
  fill: "#858585"
})));

var ICON_MAP = {
  info: InfoIcon,
  infoV2: InfoIconV2,
  infoV3: InfoIconV3,
  "user-says": UserSaysIcon,
  "bot-says": BotSaysIcon,
  entities: EntitiesIcon,
  connections: ConnectionsIcon,
  api: ApiIcon,
  gear: GearIcon,
  close: CloseIcon,
  closeV2: CloseV2Icon,
  inactive: InactiveIcon,
  active: ActiveIcon,
  edit: EditIcon,
  invisible: InvisibleIcon,
  visible: VisibleIcon,
  save: SaveIcon,
  help: HelpIcon,
  add: AddIcon,
  trash: TrashIcon,
  home: HomeIcon,
  synonym_highlight: SynonymHighlightIcon,
  synonym_duplicate: CloneIcon,
  plus: PlusIcon,
  plus2: Plus2Icon,
  minus: MinusIcon,
  "add-delay": AddDelayIcon,
  "add-entity": AddEntityIcon,
  "bot-says-colored": BotSaysColoredIcon,
  delay: DelayIcon,
  entity: EntityIcon,
  "entity-numeric-range": EntityNumericRangeIcon,
  "entity-regex": EntityRegexIcon,
  budget: BudgetIcon,
  date: DateIcon,
  time: TimeIcon,
  reorder: ReorderIcon,
  mandatory: MandatoryIcon,
  tick: SuccessIcon,
  star: StarIcon,
  "angle-down": AngleDownIcon,
  node: NodeIcon,
  story: StoryIcon,
  upload_icon: UploadIconIcon,
  task: TaskIcon,
  task_gray: TaskGreyIcon,
  taskbox: TaskboxIcon,
  outlier: OutlierIcon,
  business: BusinessIcon,
  botbreak: BotbreakIcon,
  bot: BotIcon,
  checkmark: TickIcon,
  "entity-email": EntityEmailIcon,
  client: ClientIcon,
  search: SearchIcon,
  filter: FilterIcon,
  filter_filled: FilterFilledIcon,
  transfer: TransferIcon,
  "empty-business-placeholder": EmptyBusinessPlaceholderIcon,
  error_response: RedExclamationIcon,
  success_response: TickGreenIcon,
  "tick-green": TickGreenIcon,
  question: QuestionIcon,
  "question-blue": QuestionBlueIcon,
  "question-book": QuestionBookIcon,
  arrow: ArrowIcon,
  "test-bot": TestBotIcon,
  "substory-empty": SubstoryEmptyIcon,
  quotes_open: QuotesOpenIcon,
  quotes_close: QuotesCloseIcon,
  template: TemplateIcon,
  template_general: TemplateGeneralIcon,
  template_substory: TemplateSubstoryIcon,
  template_substory_api: TemplateSubstoryApiIcon,
  "circle-more": CircleMoreIcon,
  paste: PasteIcon,
  haptik: HaptikIcon,
  profile: ProfileIcon,
  botTab: BotTabIcon,
  botTabColored: BotTabColoredIcon,
  templateTab: TemplateTabIcon,
  templateTabColored: TemplateTabColoredIcon,
  businessTab: BusinessTabIcon,
  businessTabColored: BusinessTabColoredIcon,
  grid: GridIcon,
  imagePlaceholder: PlaceholderIcon,
  filePlaceholder: PlaceholderIcon$1,
  analytics: AnalyticsIcon,
  expand: ExpandIcon,
  expandThin: ExpandThinIcon,
  shrink: ShrinkIcon,
  download: DownloadIcon,
  plusCalendar: PlusCalendar,
  caretUp: CaretUp,
  caretDown: CaretDown
};

/**
 * Based on the icon identifier (string), it returns the
 * icon component.
 * @export
 * @param {string} iconType icon identifier
 * @returns {Object} the react component corresponding to the iconType
 */
function getIcon(iconType) {
  return ICON_MAP[iconType] || function () {
    return null;
  };
}

var _excluded = ["src", "prefixClassName", "className", "size", "onClick", "innerRef", "tooltip", "tooltipPosition", "themed"];

/**
 * Icon component that renders an icon. It takes a string identifier
 * and renders the icon corresponding to that.
 */
var Icon = function Icon(_ref) {
  var _ref$src = _ref.src,
    src = _ref$src === void 0 ? "" : _ref$src,
    _ref$prefixClassName = _ref.prefixClassName,
    prefixClassName = _ref$prefixClassName === void 0 ? "" : _ref$prefixClassName,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    size = _ref.size,
    onClick = _ref.onClick,
    innerRef = _ref.innerRef,
    tooltip = _ref.tooltip,
    tooltipPosition = _ref.tooltipPosition,
    themed = _ref.themed,
    props = _objectWithoutProperties(_ref, _excluded);
  // Note: Themed only for getting themed tooltip
  if (!src) return null;
  var getSizeClassName = function getSizeClassName() {
    switch (size) {
      case Icon.SIZES.BIG:
        return styles.big;
      case Icon.SIZES.MEDIUM:
        return styles.medium;
      case Icon.SIZES.SMALL:
        return styles.small;
      case Icon.SIZES.EXTRA_SMALL:
        return styles["extra-small"];
      default:
        return styles.medium;
    }
  };
  var IconSvg = typeof src === "string" ? getIcon(src) : src;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "icon",
    ref: innerRef,
    onClick: onClick,
    className: "".concat(styles.icon, " ").concat(prefixClassName, " ").concat(className, " ").concat(getSizeClassName())
  }, themed ? /*#__PURE__*/React.createElement(Tooltip, {
    offset: {
      top: -4
    },
    tooltip: tooltip,
    themed: true
  }, /*#__PURE__*/React.createElement(IconSvg, {
    className: "".concat(prefixClassName, "-svg")
  })) : /*#__PURE__*/React.createElement(WithTooltip, {
    tooltip: tooltip,
    position: tooltipPosition,
    className: styles.iconTooltip,
    prefixClassName: "".concat(prefixClassName, "-tooltip")
  }, /*#__PURE__*/React.createElement(IconSvg, {
    className: "".concat(prefixClassName, "-svg")
  })));
};
Icon.SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  BIG: "big",
  EXTRA_SMALL: "extraSmall"
};
Icon.defaultProps = {
  src: "",
  className: "",
  tooltip: "",
  tooltipPosition: "",
  size: Icon.SIZES.MEDIUM,
  onClick: function onClick() {},
  themed: false
};
Icon.propTypes = {
  /** Can either be a string identifier for the icon (angle-down) or a react node */
  src: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** The classname to be prefixed to the icon's outer most div */
  prefixClassName: PropTypes.string,
  /** The classname to be attached to the icon's outer most div */
  className: PropTypes.string,
  /** The size of the icon (small/medium/big/px number)  */
  size: PropTypes.number,
  /** The callback function that will be called on click of the icon */
  onClick: PropTypes.func,
  /** Passes the ref to the outermost div  */
  innerRef: PropTypes.func,
  /** Tooltip for the Icon */
  tooltip: PropTypes.string,
  /** Tooltip Positioning (TOP/BOTTOM) */
  tooltipPosition: PropTypes.string,
  /** Use themed version of Icon */
  themed: PropTypes.bool
};
Icon.classNames = {
  $prefix: "Outermost element",
  "$prefix-tooltip": "Tooltip wrapping the Icon",
  "$prefix-svg": "The SVG wrapped in icon element"
};
Icon.__docgenInfo = {
  "description": "Icon component that renders an icon. It takes a string identifier\nand renders the icon corresponding to that.",
  "methods": [],
  "displayName": "Icon",
  "props": {
    "src": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "Can either be a string identifier for the icon (angle-down) or a react node"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The classname to be prefixed to the icon's outer most div"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The classname to be attached to the icon's outer most div"
    },
    "tooltip": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Tooltip for the Icon"
    },
    "tooltipPosition": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Tooltip Positioning (TOP/BOTTOM)"
    },
    "size": {
      "defaultValue": {
        "value": "Icon.SIZES.MEDIUM",
        "computed": true
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The size of the icon (small/medium/big/px number)"
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "The callback function that will be called on click of the icon"
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Use themed version of Icon"
    },
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Passes the ref to the outermost div"
    }
  }
};

export { AngleDownIcon as A, CloseIcon as C, Icon as I, PlaceholderIcon$1 as P, SearchIcon as S, TickIcon as T, InfoIconV3 as a, InfoIcon as b, SuccessIcon as c, PlaceholderIcon as d, PlusIcon as e, TrashIcon as f, ArrowIcon as g, CloseV2Icon as h, CloneIcon as i };
